import { debouncedToggleSnackBar } from 'common/utils/utils';
import _ from 'lodash';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

const getProjectsFavoritesService = ({
  account,
  patchAccount,
  toggleSnackBar,
  setFavoriteProjectsCount,
  favoriteProjectsCount,
  history,
  AppRouter
}) => {
  const isFavoriteProject = ({ id }) =>
    account.settings.favorite_projects?.includes(id);

  const addProjectToFavorites = async ({ id, name }) => {
    const { favorite_projects } = account.settings;
    let hasError = false;
    try {
      await patchAccount(account.id, {
        settings: {
          ...account.settings,
          favorite_projects: favorite_projects
            ? [...favorite_projects, id]
            : [id]
        }
      });
    } catch {
      hasError = true;
    }
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.PROJECTS,
      click_type: TRACKING.CLICK.ADD_PROJECT_TO_FAVORITES,
      project_name: name
    });
    await debouncedToggleSnackBar(
      hasError
        ? 'Add to favorites operation failed'
        : `${name} added to favorites!`,
      null,
      !hasError,
      toggleSnackBar
    );
    setFavoriteProjectsCount(favoriteProjectsCount + 1);
  };

  const removeProjectFromFavorites = async ({ id, name }) => {
    let hasError = false;
    try {
      await patchAccount(account.id, {
        settings: {
          ...account.settings,
          favorite_projects: _.without(account.settings.favorite_projects, id)
        }
      });
    } catch {
      hasError = true;
    }
    await debouncedToggleSnackBar(
      hasError
        ? 'Remove from favorites operation failed'
        : `${name} removed from favorites`,
      null,
      !hasError,
      toggleSnackBar
    );
    if (favoriteProjectsCount === 1) {
      // removed last favorite project from favorites list - redirect to all projects
      history.push(AppRouter.PROJECTS_API_ALL.path);
    }
    setFavoriteProjectsCount(favoriteProjectsCount - 1);
  };
  return {
    isFavoriteProject,
    addProjectToFavorites,
    removeProjectFromFavorites
  };
};
export default getProjectsFavoritesService;
